import { ProprieteAffichee } from "./proprieteAffichee";
import { OperatorRoles } from "./operatorRoles";

export class Operator {
  operatorId: number;
  identifiant: string;
  nom: string;
  siteId: number;
  isActif: boolean;
  roles: OperatorRoles[];
  rolesAffichees: string;


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('identifiant', 'GLOBAL.IDENTIFICATEUR'));
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    tab.push(new ProprieteAffichee('rolesAffichees','GLOBAL.ROLES'));
    return tab;
  }
}
